import React from "react";
import "./MercadoShops.css";
import MercadoShopsTable from "../components/MercadoShopsTable";
import { FormattedMessage } from "react-intl";

const MercadoShops = () => {
  return (
    <div className="mercadoshops-container">
      <div className="ms-header-container">
        <div>
          <h3>
            <FormattedMessage
              id="ready-size-products"
              defaultMessage="Productos"
            />
          </h3>
        </div>
      </div>

      {/* <div className="mercadoshops-navbar-buttons-container">
        <div className="mercadoshops-buttons-container"></div>
      </div> */}
      <div className="mercadoshops-table-container">
        <MercadoShopsTable />
      </div>
    </div>
  );
};

export default MercadoShops;
